import type { SyntheticEvent } from 'react';

// Drapeaux servis par flagcdn.com, par code pays ISO 3166-1 alpha-2.
// Les URLs sont stockées en base (`pays.url_flag`) ; ce module fournit le
// même format côté client et un repli si une image ne charge pas.
export const FLAG_CDN_WIDTH = 'w160';

/** Construit l'URL flagcdn d'un drapeau à partir d'un code pays ISO‑2 (ex: 'fr'). */
export const flagUrl = (code: string): string =>
  `https://flagcdn.com/${FLAG_CDN_WIDTH}/${code.trim().toLowerCase()}.png`;

// Placeholder neutre (SVG inline) affiché quand un drapeau échoue à charger.
export const FLAG_FALLBACK_SRC =
  "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='22'%3E%3Crect%20width='32'%20height='22'%20rx='3'%20fill='%23ECE4D3'/%3E%3Cpath%20d='M5%2011h22M16%204v14'%20stroke='%23B7AE99'%20stroke-width='1.2'%20fill='none'/%3E%3C/svg%3E";

/**
 * Handler `onError` pour un <img> de drapeau : remplace une fois l'image
 * cassée par le placeholder neutre (onerror remis à null pour éviter la boucle).
 */
export const handleFlagError = (e: SyntheticEvent<HTMLImageElement>): void => {
  const img = e.currentTarget;
  img.onerror = null;
  img.src = FLAG_FALLBACK_SRC;
};
